import { useContext, useEffect, useState } from "react";
import { FunctionsContext } from "../FunctionsContext";
import { PapsContext } from "../PapsContext";
import { StartContext } from "../StartContext";
import { startTypes } from "global/cnr/reducers/StartReducer";
import { _showAppLogs, LogContext } from "../LogContext";

export const useRegDemo = ({ isDemo, settingsDocName, showToken }) => {

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  // functionsContext
  const functionsContext = useContext(FunctionsContext);
  const { functions_cls } = functionsContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}

  const startContext = useContext(StartContext);
  const { start_handlers } = startContext ?? {}

  const [regData_state, setRegData_state] = useState({})

  useEffect(() => {

    const getData = async () => {

      try {
        const getRegData = async () => {
          start_handlers.handleAmmend_startDimmer(startTypes.fetchingReg, settingsDocName, 'pageAreaContent')
          const response_regData = await functions_cls.getRegData(pathViews.clients, pathViews.events, true, showToken)
          const { result } = response_regData ?? {}
          const regInfo = result?.result
          regInfo.eventKey = pathViews.events
          if (regInfo?.projectSettings) {
            regInfo.projectSettings.settingsDocName = pathViews.events
          }
          _showAppLogs.eventInfo && log_handlers.addLog(`✅ regInfo(${settingsDocName}) from functions`);
          setRegData_state({ regInfo })
        }
        getRegData()
      } catch (err) {
        console.error(`❌ Failed to fetch reg data`, err);
      }
    }

    isDemo && settingsDocName && getData();

  }, [pathViews]);

  return regData_state;
}; 